export default "__VITE_ASSET__BMUYnafG__"